export default "/_next/static/images/2a9af33a383ca8b9a77b6dfbd3541138.jpg";